import * as React from 'react';
import { Box, Stack, Theme, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { OffboardingWizardValues } from '../../../../types/offboardings';
import { inputSx, staggerSx } from '../../../../helpers/styles/offboardings';
import HelperText from '../HelperText';
import OptionItem from '../OptionItem';

function WhenStep() {
  const { values, setFieldValue, errors, touched, setFieldTouched } =
    useFormikContext<OffboardingWizardValues>();
  return (
    <Stack gap={2} sx={staggerSx}>
      <Stack
        gap={1.5}
        role="radiogroup"
        aria-label="When should this take effect?">
        <OptionItem
          selected={values.mode === 'IMMEDIATE'}
          onClick={() => setFieldValue('mode', 'IMMEDIATE')}
          title="Immediately"
          description="Start the offboarding the moment you finish this flow."
          aside="Right now"
        />
        <OptionItem
          selected={values.mode === 'SCHEDULED'}
          onClick={() => setFieldValue('mode', 'SCHEDULED')}
          title="Schedule a date"
          description="Pick a future date and time. You can edit or cancel up until it starts."
          aside="Future"
        />
      </Stack>
      {values.mode === 'SCHEDULED' ? (
        <Stack component="label" htmlFor="scheduledFor" gap={1}>
          <Typography variant="overline" color="text.secondary">
            Effective date
          </Typography>
          <Box
            component="input"
            id="scheduledFor"
            type="datetime-local"
            value={values.scheduledFor}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFieldValue('scheduledFor', e.target.value)
            }
            onBlur={() => setFieldTouched('scheduledFor', true)}
            aria-describedby="scheduledFor-helper"
            aria-invalid={!!(touched.scheduledFor && errors.scheduledFor)}
            sx={(theme: Theme) => inputSx(theme)}
          />
          {touched.scheduledFor && errors.scheduledFor ? (
            <HelperText id="scheduledFor-helper" tone="error">
              {errors.scheduledFor}
            </HelperText>
          ) : (
            <HelperText id="scheduledFor-helper">
              The offboarding will run automatically at the time you pick.
            </HelperText>
          )}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default WhenStep;
